import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import "./assets/scripts";
import { BrowserRouter as Router } from 'react-router-dom';
import PublicRoute from './routes/public/authRoutes.js';
import Toastr from './itrust_common/components/Toastr';
import Alert from './itrust_common/components/Alert';
import NewVersionPopUp from './itrust_common/components/others/NewVersionPopUp';
import { currentUserLoad, logout } from './itrust_common/redux/actions/authActions';
import { getBackground, removeBackground } from './itrust_common/components/HelperFunctions';
import AuthorizedRoutes from './routes/authorised/AuthorizedRoutes.js';
import AppModals from './other/AppModals.js';

function App(props) {
  const { appFontSize, currentUser } = props
  const isLogged = localStorage.getItem('Access-Token') ? true : false;
  const dispatch = useDispatch()

  useEffect(() => {
    if (isLogged) {
      handleCurrentUserLoad()
    }
  }, [])

  useEffect(() => {
    if (currentUser.id) {
      setTimeout(() => getBackground({ preferences: {}, ...currentUser }), 500)
    }
    else removeBackground()
  }, [currentUser])

  const handleCurrentUserLoad = () => {
    dispatch(currentUserLoad({ include: '*' }))
  }

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <div className={`app ${appFontSize === "large" && 'large-font'}`}>
      <Toastr />
      <Alert />
      <NewVersionPopUp />
      <AppModals />
      <Router>
        <div className="h-100">
          {isLogged ?
            <AuthorizedRoutes handleLogout={handleLogout} /> :
            <div className="h-100">
              <PublicRoute />
            </div>
          }
        </div>
      </Router>
    </div>
  )
}

const mapStateToProps = state => {
  const { auth } = state;
  return {
    currentUser: auth.user || {},
    appFontSize: auth.user?.font_size
  }
}

export default connect(mapStateToProps)(App);
